<sn-player-progress [player]="player"></sn-player-progress>
